module.exports = __webpack_public_path__ + "img/image4.ec5f7ab6.jpeg";